import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

import StaticCard from './StaticCard';
import AnimatedCard from './AnimatedCard';
export default {
  components: {
    StaticCard: StaticCard,
    AnimatedCard: AnimatedCard
  },
  props: {
    shuffle: Boolean,
    unit: String,
    digit: Number,
    time: {
      // 是否是时间模式
      type: Boolean,
      default: true
    },
    mode: {
      // 翻页模式 递增add/递减reduce/跳跃jump
      type: String,
      default: 'reduce'
    },
    previousDigitProps: {
      // 用于自定义下页上页数字/ mode为jump时候生效
      type: Number,
      default: null
    }
  },
  computed: {
    currentDigit: function currentDigit() {
      // add zero
      var currentDigit = this.digit;
      if (currentDigit < 10 && this.time) {
        currentDigit = "0".concat(currentDigit);
      }
      return currentDigit;
    },
    previousDigit: function previousDigit() {
      // to prevent a negative value
      var previousDigit;
      if (this.mode === 'add') {
        // 递增模式
        previousDigit = this.digit - 1;
      } else if (this.mode === 'reduce') {
        // 递减模式
        previousDigit = this.digit + 1;
      } else if (this.mode === 'jump') {
        // 自定义previousDigit
        previousDigit = this.previousDigitProps;
      }
      if (this.unit === 'minutes' || this.unit === 'seconds') {
        // minutes and seconds
        previousDigit = previousDigit === 60 ? 0 : previousDigit;
      } else if (this.unit === 'hours') {
        // hour
        previousDigit = previousDigit === 24 ? 0 : previousDigit;
      }
      // add zero
      if (previousDigit < 10 && this.time) {
        previousDigit = "0".concat(previousDigit);
      }
      return previousDigit;
    },
    digit1: function digit1() {
      return this.shuffle ? this.previousDigit : this.currentDigit;
    },
    digit2: function digit2() {
      return !this.shuffle ? this.previousDigit : this.currentDigit;
    },
    animation1: function animation1() {
      return this.shuffle ? 'fold' : 'unfold';
    },
    animation2: function animation2() {
      return !this.shuffle ? 'fold' : 'unfold';
    }
  }
};